import React, { useEffect, useState } from "react"
import moment from "moment"
import { Calendar, momentLocalizer } from "react-big-calendar"
import "react-big-calendar/lib/css/react-big-calendar.css"
import { useDrag, useDrop } from "react-dnd"
import DateCustomToolbar from "./DateCustomToolbar"
import MultiSelectWithCheckbox from "./MultiSelectWithCheckbox"
import { DayEvent } from "./Events"

const localizer = momentLocalizer(moment)

const ItemTypes = {
  EVENT: "event",
}


function DraggableEvent({ event }) {
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.EVENT,
    item: { id: event.id },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  console.log("evvent", event)

  return (
    <div
      ref={drag}
      className="schedule-card"
      style={{
        opacity: isDragging ? 0.5 : 1,
        backgroundColor: "#f0f0f0",
        border: "1px solid #ddd",
        padding: "5px",
        cursor: "move",
        borderRadius: "4px",
      }}
    >
      <div>
        {event.title} - {event.appointmentType}
      </div>
    </div>
  )
}

function DroppableCalendar(props) {
  const { usersRoleData, events, setEvents, droppableId, moveEvent, name, setSelectedLeftCalenderDate, setSelectedRightCalenderDate } = props

  const [roomData, setRoomData] = useState({events})
  const [currentDate, setCurrentDate] = useState(props?.currentDate)
  const [filteredClinics, setFilteredClinics] = useState([])

  useEffect(() => {
    setFilteredClinics(events?.map((each) => each?.label?.replace(/\s+/g, '')?.toLowerCase()))
  },[roomData])

  useEffect(() => {
    setRoomData((prev) => ({...prev, events}))
  }, [props])

  useEffect(() => {
    setCurrentDate(props?.currentDate)
  }, [props?.currentDate])

  useEffect(() => {
    if(name === "room1") setSelectedLeftCalenderDate(currentDate)
    if(name === "room2") setSelectedRightCalenderDate(currentDate)
  }, [currentDate])

  const [, drop] = useDrop({
    accept: ItemTypes.EVENT,
    drop: (item) => moveEvent(item.id, droppableId),
  })

  const onSelectEvent = (e) => {
    console.log("onSelectEvent", e)
  }

  const handleNavigate = (action) => {
    const newDate = new Date(currentDate)
    if (action === "PREV") {
      newDate.setDate(currentDate.getDate() - 1)
    } else if (action === "NEXT") {
      newDate.setDate(currentDate.getDate() + 1)
    }
    setCurrentDate(newDate)
  }

  const handleToday = () => {
    setCurrentDate(new Date())
  }

  const renderToolbar = (toolbarProps) => (
    <DateCustomToolbar
      {...toolbarProps}
      onNavigate={handleNavigate}
      onToday={handleToday}
      currentDate={currentDate}
      setCurrentDate={setCurrentDate}
    />
  )

  function onSelectOptions(data) {
    if(data.length === 0){
      return setRoomData((prev) => ({
        ...prev,
        events: events, // updating with all events list in case no filter selection
      }))
    }

    const ids = data?.map((each) => each?._id)
    let newEvents = events.filter((each) => ids.includes(each?.doctorId))

    setRoomData((prev) => ({
      ...prev,
      events: newEvents, // Update the filtered events list
    }))
  }
  
  const filteredUsersRoleData = usersRoleData?.filter((each) => filteredClinics?.includes(each?.label?.replace(/\s+/g, '')?.toLowerCase()))
  return (
    <div ref={drop} style={{ height: 500 }}>
      <MultiSelectWithCheckbox
        label="All Clinics"
        containerStyle={{
          width: "100%",
          maxWidth: "400px",
          display: "flex",
          flexDirection: "column",
        }}
        options={filteredUsersRoleData}
        onSelectOptions={onSelectOptions}
      />

      <Calendar
        localizer={localizer}
        events={roomData.events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: "100%" }}
        allDayMaxRows={3}
        views={["day"]}
        defaultView="day"
        components={{
          toolbar: renderToolbar,
          event: ({ event }) => <DraggableEvent event={event} />,
          day: {
            event: DayEvent,
          },
        }}
        date={currentDate}
        selectable={true}
        onSelectEvent={onSelectEvent}
      />
    </div>
  )
}

export default DroppableCalendar
